if (!customElements.get('section-cart-drawer')) {
  class TG_SectionCartDrawer extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
          this.element = this;
          this.delegateElement = new themegoal.libs.Delegate(this.element);
          this.documentDelegate = new themegoal.libs.Delegate(document.documentElement);
          this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
          this.itemCount = this.options['itemCount'];
          this.cartBagPrice = null;
      
          this.sidebarDrawer = new themegoal.components.Drawer(this);
          this.element.addEventListener('hidden.tg.Drawer', this._onDrawerClosed.bind(this));
      
          this._bindEventsListeners();
          this._syncCartBagOptionPrice();
        }

        disconnectedCallback(){
          if(this.delegateElement)this.delegateElement.destroy();
          if(this.documentDelegate)this.documentDelegate.destroy();
        }
      
        _bindEventsListeners() {
        
          this.delegateElement.on('change', '#CartNote', this._updateCartNote.bind(this));
          this.delegateElement.on('change', '[data-action="toggle-cart-bag"]', this._toggleCartBag.bind(this));
      
          this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
          this.delegateElement.on('change', '.CartItem__QuantityNum', this._updateItemQuantity.bind(this));
      
          document.addEventListener('product:added', this._onProductAdded.bind(this));
      
          // re-render the drawer cart with event cart:refresh
          this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));
        }
      
        _updateCartNote(event, target) {
          fetch(window.routes.cartUrl + '/update.js', {
            body: JSON.stringify({ note: target.value }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          });
        }

        _toggleCartBag(event, target) {
          var _this = this;
          var variantId = target.getAttribute('data-variant-id');
          var quantity = target.checked ? 1 : 0;
          var updates = {};

          if (!variantId) {
            return;
          }

          updates[variantId] = quantity;

          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          target.disabled = true;

          fetch(window.routes.cartUrl + '/update.js', {
            body: JSON.stringify({ updates: updates }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('Failed to update cart bag.');
            }

            return response.json();
          }).then(function (content) {
            _this.itemCount = content['item_count'];

            return _this._rerenderCart();
          }).catch(function () {
            target.checked = !target.checked;
            target.disabled = false;
          }).then(function () {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          });

          event.preventDefault();
        }

        _syncCartBagOptionPrice() {
          var _this = this;
          var bagOptionElement = this.element.querySelector('[data-action="toggle-cart-bag"]');
          var bagLabelElement = this.element.querySelector('[data-cart-bag-label]');
          var currentPrice = null;
          var labelBase = null;
          var labelWithPriceTemplate = null;

          if (!bagOptionElement || !bagLabelElement) {
            return Promise.resolve();
          }

          labelBase = bagLabelElement.getAttribute('data-label-base') || bagLabelElement.textContent.trim();
          labelWithPriceTemplate = bagLabelElement.getAttribute('data-label-with-price-template') || (labelBase + ' (+__PRICE__)');
          currentPrice = parseInt(bagOptionElement.getAttribute('data-current-price'), 10);

          if (!isNaN(currentPrice)) {
            this.cartBagPrice = currentPrice;
          }

          if (this.cartBagPrice !== null && !isNaN(this.cartBagPrice)) {
            bagLabelElement.textContent = labelWithPriceTemplate.replace('__PRICE__', this._formatCartBagPrice(this.cartBagPrice));
            return Promise.resolve();
          }

          bagLabelElement.textContent = labelBase;

          return this._fetchCartBagVariantPrice(bagOptionElement.getAttribute('data-variant-id')).then(function (price) {
            if (isNaN(price)) {
              return;
            }

            _this.cartBagPrice = price;
            bagLabelElement.textContent = labelWithPriceTemplate.replace('__PRICE__', _this._formatCartBagPrice(price));
          }).catch(function () {
            bagLabelElement.textContent = labelBase;
          });
        }

        _fetchCartBagVariantPrice(variantId) {
          var rootUrl = window.routes.rootUrlWithoutSlash || '';

          if (this.cartBagPrice !== null && !isNaN(this.cartBagPrice)) {
            return Promise.resolve(this.cartBagPrice);
          }

          if (!variantId) {
            return Promise.reject(new Error('Missing bag variant id.'));
          }

          return fetch(rootUrl + '/variants/' + variantId + '.js', {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (response) {
            if (response.ok) {
              return response.json();
            }

            return fetch(rootUrl + '/variants/' + variantId + '.json', {
              credentials: 'same-origin',
              method: 'GET'
            }).then(function (fallbackResponse) {
              if (!fallbackResponse.ok) {
                throw new Error('Failed to fetch bag variant.');
              }

              return fallbackResponse.json();
            });
          }).then(function (content) {
            var variant = content.variant || content;

            if (!variant || typeof variant.price === 'undefined') {
              throw new Error('Bag variant price not found.');
            }

            return parseInt(variant.price, 10);
          });
        }

        _formatCartBagPrice(price) {
          return themegoal.helpers.Currency.formatMoney(price, window.theme.moneyFormat);
        }
      
        _updateItemQuantity(event, target) {
          var _this = this;
      
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
      
          var quantity = null,
              elementToAnimate = null;
      
          if (target.tagName === 'INPUT') {
            quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
          } else {
            //+ - button
            quantity = parseInt(target.getAttribute('data-quantity'));
          }
      
          // If the quantity is 0, then we will animate the product with a removal effect
          if (quantity === 0) {
            elementToAnimate = target.closest('.CartItem__Wrapper');
          }
      
          fetch(window.routes.cartChangeUrl + '.js', {
            body: JSON.stringify({ id: target.getAttribute('data-line-id'), quantity: quantity }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (cart) {
            cart.json().then(function (content) {
              _this.itemCount = content['item_count'];
              _this._rerenderCart(elementToAnimate);
      
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
            });
          });
      
          event.preventDefault();
        }
      
        _onProductAdded(event) {
          var _this = this;
      
          this.itemCount += event.detail.quantity;
      
          this._rerenderCart().then(function () {
            _this.sidebarDrawer.show();
          });
        }
      
        _onDrawerClosed() {
          let cartDrawerNoteElement = document.getElementById('CartDrawerNoteCollapse');
          if(cartDrawerNoteElement){
            let cartDrawerNoteCollapse = new themegoal.components.Collapse(cartDrawerNoteElement, { toggle: false });
            cartDrawerNoteCollapse.hide();
          }
        }
      
        _rerenderCart(elementToAnimate) {
          var _this = this;
      
          // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
          return fetch(window.routes.cartUrl + '?section_id=' + this.options['sectionId'] + '&timestamp=' + Date.now(), {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (content) {
            // If there is an element to animate, we animate it using a transition
            if ( elementToAnimate ) {
              themegoal.libs.anime({
                targets: elementToAnimate,
                opacity: 0,
                height: 0,
                duration: 500,
                easing: 'easeOutCubic',
                complete: function(anim) {
                  content.text().then(function (html) {
                    _this._replaceContent(html);
                  });
                }
              });
            } else {
              content.text().then(function (html) {
                _this._replaceContent(html);
              });
            }
          });
        }
      
        _replaceContent(html) {
          let _this = this;
      
          let tempElement = document.createElement('div');
          tempElement.innerHTML = html;

          let currentForm = this.element.querySelector('.Form--cart');
          let nextCartElement = tempElement.querySelector('.CartDrawer');
          let nextForm = tempElement.querySelector('.Form--cart');
          let drawerBodyElement = this.element.querySelector('.Drawer__Body');
          let currentScrollPosition = drawerBodyElement ? drawerBodyElement.scrollTop : 0;

          if (!currentForm || !nextCartElement || !nextForm) {
            this._replaceContentFallback(tempElement);
            return;
          }

          this.element.setAttribute('data-section-settings', nextCartElement.getAttribute('data-section-settings'));
          this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

          this._syncElement(currentForm.querySelector('.Drawer__Body'), nextForm.querySelector('.Drawer__Body'), '.CartDrawer__ShippingAmountNotice');
          this._syncElement(currentForm.querySelector('.Drawer__Body'), nextForm.querySelector('.Drawer__Body'), '.CartDrawer__Items');
          this._syncElement(currentForm.querySelector('.Drawer__Body'), nextForm.querySelector('.Drawer__Body'), '.CartDrawer__BodySummary');
          this._syncElement(currentForm.querySelector('.Drawer__Body'), nextForm.querySelector('.Drawer__Body'), '.EmptyResult');
          this._syncFooterContent(currentForm, nextForm);

          drawerBodyElement = this.element.querySelector('.Drawer__Body');

          if (drawerBodyElement) {
            drawerBodyElement.scrollTop = currentScrollPosition;
          }
      
          // We can also update the dot and the quantity of header icon
          let cartResult = JSON.parse(nextCartElement.getAttribute('data-section-settings'));
      
          let cartCount = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble')),
          cartText = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountText')),
          cartQuantity = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble__Count'));
      
          this.itemCount = cartResult['itemCount'];
      
          cartCount.forEach(function (item) {
            if (_this.itemCount === 0) {
              item.classList.remove('Visible'); 
            } else {
              item.classList.add('Visible');
            }
          });
      
          cartText.forEach(function (item) {
            if (_this.itemCount === 0) {
              item.classList.add('Visible'); 
            } else {
              item.classList.remove('Visible');
            }
          });
      
          cartQuantity.forEach(function (item) {
            item.textContent = _this.itemCount;
          });


          if(this.options["freeShippingThreshold"]){
            let freeShippingElement = this.element.querySelector(".CartDrawer__ShippingAmountNotice");
            
      
            if(freeShippingElement){
              let cartTotalPrice = freeShippingElement.getAttribute("data-cart-total-price");
              let cartCurrencySymbol = freeShippingElement.getAttribute("data-cart-currency-symbol");
      
              cartTotalPrice = parseInt(cartTotalPrice);
      
              let freeShippingAmount = Math.round(this.options["freeShippingAmount"] * (Shopify.currency.rate || 1));
      
              if(cartTotalPrice >= freeShippingAmount){
                freeShippingElement.innerHTML = this.options["freeShippingString"];
              }else{
                let freeShippingAmountString = this.options["freeShippingAmountString"];
                freeShippingAmountString = freeShippingAmountString.replace("remaining__amount", "" + cartCurrencySymbol + (freeShippingAmount - cartTotalPrice)/100);
                freeShippingElement.innerHTML = freeShippingAmountString;
              }
            }
          }

          this._syncCartBagOptionPrice();
        
        }

        _replaceContentFallback(tempElement) {
          let currentForm = this.element.querySelector('.Form--cart');
          let nextForm = tempElement.querySelector('.Form--cart');
          let nextCartElement = tempElement.querySelector('.CartDrawer');
          let cartNodeParent = currentForm ? currentForm.parentNode : null;
          let drawerBodyElement = this.element.querySelector('.Drawer__Body');
          let currentScrollPosition = drawerBodyElement ? drawerBodyElement.scrollTop : 0;

          if (!currentForm || !nextForm || !cartNodeParent) {
            return;
          }

          cartNodeParent.replaceChild(nextForm, currentForm);

          drawerBodyElement = this.element.querySelector('.Drawer__Body');

          if (drawerBodyElement) {
            drawerBodyElement.scrollTop = currentScrollPosition;
          }

          if (nextCartElement) {
            this.element.setAttribute('data-section-settings', nextCartElement.getAttribute('data-section-settings'));
            this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
          }
        }

        _syncFooterContent(currentForm, nextForm) {
          let currentFooter = currentForm.querySelector('.Drawer__Footer');
          let nextFooter = nextForm.querySelector('.Drawer__Footer');

          if (currentFooter && !nextFooter) {
            currentFooter.parentNode.removeChild(currentFooter);
            return;
          }

          if (!currentFooter && nextFooter) {
            currentForm.appendChild(nextFooter);
            return;
          }

          if (!currentFooter || !nextFooter) {
            return;
          }

          this._syncElement(currentFooter, nextFooter, '.CartDrawer__Checkout');
        }

        _syncElement(currentContainer, nextContainer, selector) {
          let currentElement = currentContainer ? currentContainer.querySelector(selector) : null;
          let nextElement = nextContainer ? nextContainer.querySelector(selector) : null;

          if (currentElement && nextElement) {
            currentElement.parentNode.replaceChild(nextElement, currentElement);
            return;
          }

          if (currentElement) {
            currentElement.parentNode.removeChild(currentElement);
            return;
          }

          if (currentContainer && nextElement) {
            currentContainer.appendChild(nextElement);
          }
        }

        _syncRepeatedElements(currentContainer, nextContainer, selector, beforeSelector) {
          let currentElements = themegoal.helpers.Dom.nodeListToArray(currentContainer.querySelectorAll(selector));
          let nextElements = themegoal.helpers.Dom.nodeListToArray(nextContainer.querySelectorAll(selector));
          let anchor = beforeSelector ? currentContainer.querySelector(beforeSelector) : null;

          currentElements.forEach(function (element) {
            if (element.parentNode) {
              element.parentNode.removeChild(element);
            }
          });

          nextElements.forEach(function (element) {
            if (anchor && anchor.parentNode === currentContainer) {
              currentContainer.insertBefore(element, anchor);
            } else {
              currentContainer.appendChild(element);
            }
          });
        }
        
    
  }
        
  customElements.define('section-cart-drawer', TG_SectionCartDrawer);
}
